import { useEffect } from 'react';
import { connect } from '../decorators/connect';

const enhance = connect(({ routerStore }) => ({
    login() {
        window.opener.postMessage(
            { ...routerStore.query, provider: routerStore.params.provider },
            window.location.origin,
        );
        window.close();
    },
}));

function LoginWithSharingProviderPage({ login }) {
    useEffect(() => {
        login();
    }, []);
    return null;
}

export default enhance(LoginWithSharingProviderPage);
